import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPatientApprovalsDetails } from 'src/app/_interfaces/approvals/lcaPatientApprovals.interface';
import { FinglodineSubscriptionsResponseData } from 'src/app/_models/PSP/finglodine-subscriptions';
import { PSPPatientRespond } from 'src/app/_models/PSP/psp-patient.model';
import { GenericResponse } from 'src/app/_models/response.model';



@Injectable({
  providedIn: 'root'
})
export class PSPPatientService {
  url = 'api/AdminPatients/';
  getPatientPspSunbscriptionUrl = 'api/GePatientPspSubscriptions/';
  finglodineSubscriptionUrl: string = 'api/PSPSubscription/finglodine/';


  constructor(private http: HttpClient) { }

  getPatientByPhone(params): Observable<PSPPatientRespond> {
    return this.http.get<PSPPatientRespond>(`${this.url}GetPatientByPhone`, { params });
  }

  uploadPspfinglodineSubscriptionlData(finglodineSubscriptionlData: FormData): Observable<GenericResponse<IPatientApprovalsDetails>> {
    return this.http.post<GenericResponse<IPatientApprovalsDetails>>(this.finglodineSubscriptionUrl, finglodineSubscriptionlData)
  }

  getFinglodineSubscriptionData(params):Observable<FinglodineSubscriptionsResponseData>{
    return this.http.get<FinglodineSubscriptionsResponseData>(`${this.url}finglodine/patients`, {params});
  }

}
